/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import ParentComponent from "../ParentComponent";
import { AuthContext } from "../AuthContext";
import ar from "../../locale";

export default class PhotoUploader extends ParentComponent {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    this.state = {
      user: context.user,
      showCropper: false,
      imageSrc: null,
      croppedAreaPixels: null,
      zoom: 1,
      crop: { x: 0, y: 0 },
      cropSize: {
        width: this.props.cropwidth || 200,
        height: this.props.cropheight || 200,
      },
      aspect: this.props.aspect || 4 / 2,
    };
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  updateState = () => {
    this.setState((prev) => {
      return { ...prev };
    });
  };

  toggleCropper = () => {
    this.state.showCropper = !this.state.showCropper;
    this.updateState();
  };

  openPicker = (e) => {
    this.file.click(e);
  };

  onZoomChange = (zoom) => {
    this.state.zoom = zoom;
    this.updateState();
  };

  cancelPic = () => {
    this.state.croppedAreaPixels = null;
    this.file.value = null;
    this.state.imageSrc = null;
    this.state.avatar = null;
    this.toggleCropper();
  };

  readFile = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.addEventListener("load", () => resolve(reader.result), false);
      reader.readAsDataURL(file);
    });
  };

  onFileChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const imageDataUrl = await this.readFile(e.target.files[0]);
      this.state.imageSrc = imageDataUrl;
      this.toggleCropper();
    } else {
      this.cancelPic();
    }
  };

  onCropChange = (crop) => {
    this.state.crop = crop;
    this.updateState();
  };

  onCropComplete = async (croppedArea, croppedAreaPixels) => {
    this.state.croppedAreaPixels = croppedAreaPixels;
    this.updateState();
  };

  saveAvatar = async () => {
    let { imageSrc } = this.state;
    this.state.avatar = imageSrc;
    this.file.value = null;
    this.state.imageSrc = null;
    this.toggleCropper();
    let res = await fetch(imageSrc);
    let blob = await res.blob();
    this.props.onSaveAvatar(blob);
  };

  render() {
    let { showCropper, imageSrc } = this.state;
    let { savetext, avatar } = this.props;
    return (
      <div>
        <input
          type="file"
          ref={(file) => (this.file = file)}
          className="d-none"
          onChange={this.onFileChange}
          accept="image/*"
        />
        {!showCropper && (
          <div className="card">
            <div className="position-absolute d-flex profile_overlay">
              <button
                type="button"
                onClick={this.openPicker}
                className="btn btn-default bg-transparent"
                data-toggle="tooltip"
                data-placement="top"
                title={ar.edit_profile_pic}
              >
                <i className="fa fa-edit text-info"></i>
              </button>
            </div>
            <div className="card-body d-flex flex-row justify-content-center">
              <div className="h200 d-inline-block">
                {this.state.avatar && (
                  <img
                    src={this.state.avatar}
                    alt="profile"
                    className="avatarc h200"
                  />
                )}
                {!this.state.avatar && avatar && (
                  <img src={avatar} alt="profile" className="avatarc h200" />
                )}
                {!this.state.avatar && !avatar && (
                  <div className="h200 d-flex flex-column justify-content-center text-center">
                    {ar.upload_logo_here}
                    <br />
                    {ar.click_edit_to_add_new}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {showCropper && imageSrc && (
          <div className="card">
            <div className="card-body position-relative m-auto">
              <img src={imageSrc} className="h200 position-relative" />
              <div className="mt-5">
                <button
                  type="button"
                  className="btn btn-rounded btn-info m-1"
                  onClick={this.saveAvatar}
                >
                  {savetext || ar.save}
                </button>
                <button
                  type="button"
                  className="btn btn-rounded btn-danger m-1"
                  onClick={this.cancelPic}
                >
                  {ar.cancel}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
